import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InfoBoxComponent } from 'app/shared/components/info-box/info-box.component';

@Component({
    selector: 'app-bulk-service-info',
    imports: [InfoBoxComponent],
    templateUrl: './bulk-service-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkServiceInfoComponent {}
